export default class WidgetConfig {}
